var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStopWatch = function SvgStopWatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 106 118"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F9",
    stroke: "#AAB2C5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M70.374 18.851h-33.81v-6.673C36.564 6.005 41.735 1 47.908 1H59.03c6.34 0 11.345 5.172 11.345 11.178zM93.76 38.704l-8.675-9.342 8.341-7.675c1.168-1.168 3.003-1 4.004.167l4.838 5.172c1.168 1.168 1.001 3.003-.166 4.004zM11.845 38.704l8.675-9.342-8.342-7.675c-1.168-1.168-3.003-1-4.004.167l-4.838 5.172c-1.168 1.168-1.001 3.003.167 4.004z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F3F9",
    stroke: "#AAB2C5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M52.885 116.95c28.656 0 51.886-23.006 51.886-51.385 0-28.38-23.23-51.385-51.886-51.385C24.23 14.18 1 37.186 1 65.565c0 28.379 23.23 51.385 51.885 51.385"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M52.885 109.275c24.325 0 44.044-19.57 44.044-43.71s-19.72-43.71-44.044-43.71c-24.325 0-44.044 19.57-44.044 43.71s19.72 43.71 44.044 43.71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6DCE8",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M96.93 65.565c0 .834 0 1.501-.167 2.335-1.168-23.19-20.354-41.374-43.878-41.374-23.523 0-42.71 18.351-44.044 41.208 0-.834-.167-1.502-.167-2.336 0-24.19 19.854-43.71 44.045-43.71 24.524.166 44.21 19.686 44.21 43.877Z",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6DCE8",
    d: "M88.254 65.565c0 1.334-.167 2.502-.167 3.67-.166 2.67-3.17 4.171-5.672 3.003l-18.519-9.676a3.89 3.89 0 0 1-2.169-3.504V37.203c0-2.836 2.837-4.838 5.506-3.67 12.346 5.505 21.021 17.684 21.021 32.032",
    opacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAB2C5",
    d: "M55.388 63.73H50.55l.167-21.689c0-1.334 1.168-2.335 2.335-2.335 1.335 0 2.336 1.167 2.336 2.335z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAB2C5",
    d: "M49.715 66.733c0-1.669 1.335-3.17 3.17-3.17s3.003 1.334 3.003 3.003c0 1.668-1.334 3.17-3.17 3.17-1.668 0-3.003-1.168-3.003-3.003"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAB2C5",
    d: "M83.917 82.749c-.167.167-.668.167-.835.167l-30.697-15.35c-.334-.166-.5-.666-.334-1 .167-.334.668-.5 1.001-.334L83.75 81.581c.333.167.5.667.333 1 .167.168 0 .168-.166.168"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#D6DCE8",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M47.38 66.733c0-2.837 2.336-5.172 5.339-5.34 3.003-.166 5.171 2.337 5.171 5.173s-2.335 5.172-5.338 5.338c-2.836.334-5.172-2.168-5.172-5.171Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6DCE8",
    d: "M54.22 96.096h-2.836c-.5 0-1.001.333-1.001 1v7.007c0 .501.334 1.001 1 1.001h2.837c.5 0 1.001-.333 1.001-1.001v-7.006c-.167-.501-.5-1.001-1.001-1.001M54.22 25.19h-2.836c-.5 0-1.001.335-1.001 1.002v7.007c0 .5.334 1.001 1 1.001h2.837c.5 0 1.001-.334 1.001-1.001v-7.007c-.167-.5-.5-1.001-1.001-1.001M21.354 62.395h-7.007c-.5 0-1.001.334-1.001 1.001v2.836c0 .5.333 1.001 1 1.001h7.008c.5 0 1-.334 1-1v-2.837c0-.667-.5-1.001-1-1.001M67.083 102.286a2.335 2.335 0 1 0-1.673-4.36 2.335 2.335 0 0 0 1.673 4.36M81.437 92.818a2.336 2.336 0 1 0-3.36-3.245 2.336 2.336 0 0 0 3.36 3.245M18.253 78.474a2.336 2.336 0 1 0-1.513-4.42 2.336 2.336 0 0 0 1.513 4.42M27.78 92.106a2.336 2.336 0 1 0-3.24-3.367 2.336 2.336 0 0 0 3.24 3.367M41.767 99.92a2.336 2.336 0 1 0-4.358-1.683 2.336 2.336 0 0 0 4.358 1.683M42.269 32.568a2.336 2.336 0 1 0-1.47-4.434 2.336 2.336 0 0 0 1.47 4.434M28.947 40.406a2.336 2.336 0 1 0-3.207-3.397 2.336 2.336 0 0 0 3.207 3.397M20.155 53.02a2.169 2.169 0 1 0-4.031-1.6 2.169 2.169 0 0 0 4.031 1.6"
  })));
};
export default SvgStopWatch;